export default {
  title: 'Preferências de privacidade',
  summary: 'Valorizamos sua privacidade. Usamos cookies essenciais para manter o site funcionando com segurança. Com sua permissão, ativamos cookies opcionais para melhorar sua experiência e entender o uso das nossas páginas.',
  acceptAll: 'Aceitar tudo',
  rejectAll: 'Recusar opcionais',
  customize: 'Personalizar',
  save: 'Salvar preferências',
  privacy: 'Política de privacidade',
  essentialTitle: 'Essenciais',
  essentialDescription: 'Necessários para login, segurança, preferências, sessão e funcionamento básico.',
  analyticsTitle: 'Estatística',
  analyticsDescription: 'Ajuda a entender uso, navegação e desempenho sem impedir o funcionamento se recusado.',
  marketingTitle: 'Marketing',
  marketingDescription: 'Permite tags de publicidade, remarketing e gerenciadores de tags.',
};
